"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateAccessRoleAssign = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const accessRoleAssignMutation = (0, client_1.gql) `
  mutation AccessRoleAssign($workspaceId: ID!, $roles: [RoleAssignInput!]!) {
    accessRoleAssign(workspace: $workspaceId, roles: $roles) {
      workspaceId
      permissions
      name
      isDefaultForNewUsers
      isDefaultAccessRoleManager
      isDefaultAccessRoleEmployee
      id
      assigns {
        userId
        created
      }
    }
  }`;
const mutateAccessRoleAssign = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(accessRoleAssignMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.accessRoleAssign;
};
exports.mutateAccessRoleAssign = mutateAccessRoleAssign;
